// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__1M84y","selected":"pagination_selected__1Zhr1"};